import React, { useState, useEffect } from 'react'
import { FaTimes, FaInfoCircle, FaExclamationTriangle, FaCheckCircle, FaExclamationCircle } from 'react-icons/fa'
import api from '../api/api'

const NotificationToast = () => {
    const [toasts, setToasts] = useState([])
    
    useEffect(() => {
        fetchToastNotifications()
    }, [])
    
    const fetchToastNotifications = async () => {
        try {
            const { data } = await api.get('/home/notifications/active', {
                params: { userType: 'all' }
            })
            
            // Filter only toast type
            const toastNotifications = data.notifications.filter(n => n.displayType === 'toast')
            
            // Track views
            toastNotifications.forEach(n => {
                api.post(`/home/notifications/${n._id}/view`).catch(() => {})
            })
            
            // Show toasts one by one with delay
            toastNotifications.forEach((notification, index) => {
                setTimeout(() => {
                    addToast(notification)
                }, index * 500)
            })
            
        } catch (error) {
            console.error('Error:', error)
        }
    }
    
    const addToast = (notification) => {
        const id = notification._id
        
        setToasts(prev => [...prev, { ...notification, id }])
        
        // Auto-remove after duration (based on priority)
        const duration = notification.priority === 'urgent' ? 10000 : 5000
        
        setTimeout(() => {
            removeToast(id)
        }, duration)
    }
    
    const removeToast = (id) => {
        setToasts(prev => prev.filter(t => t.id !== id))
        
        // Track dismiss
        api.post(`/home/notifications/${id}/dismiss`).catch(() => {})
    }
    
    const getIcon = (type) => {
        const icons = {
            info: <FaInfoCircle className='text-blue-500' />,
            warning: <FaExclamationTriangle className='text-yellow-500' />,
            success: <FaCheckCircle className='text-green-500' />,
            error: <FaExclamationCircle className='text-red-500' />,
            maintenance: <FaExclamationTriangle className='text-purple-500' />
        }
        return icons[type] || icons.info
    }
    
    const getBgColor = (type) => {
        const colors = {
            info: 'bg-blue-50 border-blue-500',
            warning: 'bg-yellow-50 border-yellow-500',
            success: 'bg-green-50 border-green-500',
            error: 'bg-red-50 border-red-500',
            maintenance: 'bg-purple-50 border-purple-500'
        }
        return colors[type] || colors.info
    }
    
    if (toasts.length === 0) return null
    
    return (
        <div className='fixed top-20 right-4 z-[9999] space-y-3 max-w-md'>
            {toasts.map((toast) => (
                <div
                    key={toast.id}
                    className={`${getBgColor(toast.type)} border-l-4 p-4 rounded-lg shadow-lg animate-slideIn`}
                >
                    <div className='flex items-start gap-3'>
                        {/* Icon */}
                        <div className='text-2xl flex-shrink-0 mt-1'>
                            {toast.icon ? (
                                <span>{toast.icon}</span>
                            ) : (
                                getIcon(toast.type)
                            )}
                        </div>
                        
                        {/* Content */}
                        <div className='flex-1'>
                            <h4 className='font-bold text-gray-800 mb-1'>
                                {toast.title}
                            </h4>
                            <p className='text-sm text-gray-600'>
                                {toast.message}
                            </p>
                        </div>
                        
                        {/* Close Button */}
                        {toast.isDismissible && (
                            <button
                                onClick={() => removeToast(toast.id)}
                                className='text-gray-400 hover:text-gray-600 flex-shrink-0'
                            >
                                <FaTimes />
                            </button>
                        )}
                    </div>
                </div>
            ))}
            
            <style jsx>{`
                @keyframes slideIn {
                    from {
                        transform: translateX(100%);
                        opacity: 0;
                    }
                    to {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
                .animate-slideIn {
                    animation: slideIn 0.3s ease-out;
                }
            `}</style>
        </div>
    )
}

export default NotificationToast